module.exports = __webpack_public_path__ + "static/cnpq-aee09416a89aa9fcf59dd53116d5582b.png";